import { Form, Input, Select } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'passkey.enabled',
  'passkey.allow_insecure_origin',
  'passkey.rp_display_name',
  'passkey.rp_id',
  'passkey.origins',
  'passkey.user_verification',
  'passkey.attachment_preference',
]

const USER_VERIFICATION_OPTIONS = [
  { label: '推荐使用（用户可选）', value: 'preferred' },
  { label: '强制要求', value: 'required' },
  { label: '不建议使用', value: 'discouraged' },
]

const ATTACHMENT_OPTIONS = [
  { label: '不限制', value: '' },
  { label: '本设备内置', value: 'platform' },
  { label: '外接设备', value: 'cross-platform' },
]

export default function PasskeySection({ options }: { options: OptionsAPI }) {
  const { get, patch } = options

  return (
    <SettingSectionCard title="Passkey" subtitle="WebAuthn 无密码登录与高级配置" keys={KEYS} options={options}>
      <Form layout="vertical">
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="允许 Passkey 登录">
            <InstantSwitch options={options} optionKey="passkey.enabled" />
          </Form.Item>
          <Form.Item label="允许不安全的 Origin（HTTP）" extra="仅开发环境">
            <InstantSwitch options={options} optionKey="passkey.allow_insecure_origin" />
          </Form.Item>
          <Form.Item label="服务显示名称">
            <Input value={get('passkey.rp_display_name')} onChange={(v) => patch({ 'passkey.rp_display_name': v })} />
          </Form.Item>
          <Form.Item label="网站域名标识 (RP ID)" extra="不含 http(s)://">
            <Input value={get('passkey.rp_id')} onChange={(v) => patch({ 'passkey.rp_id': v })} />
          </Form.Item>
          <Form.Item label="安全验证级别">
            <Select
              value={get('passkey.user_verification', 'preferred')}
              onChange={(v) => patch({ 'passkey.user_verification': v })}
              options={USER_VERIFICATION_OPTIONS}
            />
          </Form.Item>
          <Form.Item label="设备类型偏好">
            <Select
              value={get('passkey.attachment_preference')}
              onChange={(v) => patch({ 'passkey.attachment_preference': v ?? '' })}
              options={ATTACHMENT_OPTIONS}
              allowClear
            />
          </Form.Item>
        </div>
        <Form.Item label="允许的 Origins" extra="逗号分隔 https 域名，留空则使用服务器地址">
          <Input.TextArea
            value={get('passkey.origins')}
            onChange={(v) => patch({ 'passkey.origins': v })}
            autoSize={{ minRows: 2, maxRows: 4 }}
          />
        </Form.Item>
      </Form>
    </SettingSectionCard>
  )
}
